import { isDeliveryZone } from '../saleOrigin';

/**
 * Cada linha de /sales-temporary é um ITEM, não uma venda: a venda em aberto é
 * a mesa (ou o pedido de delivery), identificada por `sale_zone_area_object_id`.
 * Por isso a contagem é de zonas distintas, e não o `meta.total` da listagem.
 */

export interface TemporarySale {
  id: number;
  total: number | string;
  sale_zone_area_object_id?: number | string | null;
}

export interface TemporaryGroup {
  total: number;
  count: number;
}

export interface TemporaryTotals extends TemporaryGroup {
  tables: TemporaryGroup;
  delivery: TemporaryGroup;
}

const toNumber = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function summarizeTemporary(rows: TemporarySale[]): TemporaryTotals {
  const groups = {
    tables: { total: 0, zones: new Set<string>() },
    delivery: { total: 0, zones: new Set<string>() },
  };

  rows.forEach((row) => {
    const group = isDeliveryZone(row.sale_zone_area_object_id) ? groups.delivery : groups.tables;
    group.total += toNumber(row.total);
    group.zones.add(String(row.sale_zone_area_object_id ?? `item-${row.id}`));
  });

  const tables = { total: groups.tables.total, count: groups.tables.zones.size };
  const delivery = { total: groups.delivery.total, count: groups.delivery.zones.size };

  return {
    total: tables.total + delivery.total,
    count: tables.count + delivery.count,
    tables,
    delivery,
  };
}
